import React from 'react';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { InputText, SelectCustom } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import { OptionProps } from '@/components/Select';
import Bank from '@/model/Bank';
import { FormInputNamePix } from '../../types';

interface RegisterContentProps {
  banks: Bank[];
  formData: FormData;
  formErrors: FormErrors;
  onChange: OnChangeFormInput;
}

export const RegisterPix: React.FC<RegisterContentProps> = ({
  banks,
  formData,
  formErrors,
  onChange,
}) => {
  const pixTypes: OptionProps[] = [
    {
      value: '0',
      label: 'CPF/CNPJ',
    },
    {
      value: '1',
      label: 'Celular',
    },
    {
      value: '2',
      label: 'E-mail',
    },
    {
      value: '3',
      label: 'Chave aleatória',
    },
  ];
  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
      }}
    >
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <SelectCustom
              name="bankId"
              label="Instituição"
              placeholder="Selecione ou digite a instituição"
              value={formData[FormInputNamePix.bankId]}
              onChange={e => onChange(FormInputNamePix.bankId)(e?.value as string)}
              error={formErrors?.bankId && formErrors.bankId[0]}
              options={banks.map(bank => ({
                label: bank.fullName,
                value: bank.id,
              }))}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <SelectCustom
              name="pixKeyType"
              label="Tipo"
              placeholder="Selecione ou digite o tipo"
              value={formData[FormInputNamePix.pixKeyType]}
              onChange={e => onChange(FormInputNamePix.pixKeyType)(e?.value as string)}
              error={formErrors?.pixKeyType && formErrors.pixKeyType[0]}
              options={pixTypes}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <InputText
              name="key"
              label="Pix"
              placeholder="Digite a chave pix"
              value={formData[FormInputNamePix.key]}
              maxLength={40}
              onChange={e => onChange(FormInputNamePix.key)(e.target.value)}
              error={formErrors?.key && formErrors.key[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <InputText
              name="recipient"
              label="Beneficiário"
              placeholder="Informe o beneficiário"
              value={formData[FormInputNamePix.recipient]}
              onChange={e => onChange(FormInputNamePix.recipient)(e.target.value)}
              error={formErrors?.recipient && formErrors.recipient[0]}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
